import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sd-beton-order-cms-modal',
  templateUrl: './beton-order-cms-modal.component.html',
  styleUrls: ['./beton-order-cms-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BetonOrderCmsModalComponent {}
